import { Component, input } from '@angular/core';
import { SharedModule } from 'src/app/core/shared.module';

@Component({
  selector: 'v-card-image-header',

  imports: [SharedModule],
  templateUrl: './image-header.component.html',
  styleUrl: './image-header.component.scss',
})
export class VCardImageHeaderComponent {
  /**
   * The text to display in the header
   */
  readonly text = input('Header');

  /**
   * The image to display in the header
   */
  readonly image = input('');

  readonly imageClass = input('');
}
